import React from "react";
import WelcomeStep from "./steps/WelcomeStep";
import TemplateStep from "./steps/TemplateStep";
import ColumnStep from "./steps/ColumnStep";
import BulletsStep from "./steps/BulletsStep";
import DownloadStep from "./steps/DownloadStep";

const WalkthroughStepLookup = {
  welcome: <WelcomeStep />,
  template: <TemplateStep />,
  column: <ColumnStep />,
  bullets: <BulletsStep />,
  download: <DownloadStep />,
};

export default WalkthroughStepLookup;
